import { reasonCodes } from '../../constants/returns';

/* eslint-disable no-param-reassign */
export const buildHrtvItemPayloads = (returnableItems: array) =>
  returnableItems.reduce((obj: Object, item: Object) => {
    if (!item.statusCodes) {
      obj[item.lineItemId] = {
        lineItemId: item.lineItemId,
        mVendorNumber: item.mVendorNumber,
        depNbr: item.department,
        classNumber: item.itemClass,
        subClass: item.itemSubClass,
        stateCd: item.shipToAddress.state,
        itemCost: item.itemCost,
        sku: item.sku,
        upcCode: item.upcCode,
      };
    }
    return obj;
  }, {});
/* eslint-enable no-param-reassign */

export const ssrEligibilitySuccessActionData = (
  state: Object,
  action: Object
) => {
  const {
    payload: { response },
  } = action;
  const {
    billingAddress: ssrCreateBillingAddress,
    orderLineList: { orderLine },
    orderId,
    emailId,
  } = response;

  return {
    ...state,
    ssrCreateBillingAddress,
    ssrCreateShipFromAddress: orderLine[0].shipToAddress,
    mVendorNumber: orderLine[0].mVendorNumber,
    orderId,
    emailId,
  };
};

/* eslint-disable no-param-reassign */
export const mapSsrItems = (orderLine: array) =>
  orderLine.reduce((obj: Object, item: Object) => {
    obj[item.lineItemId] = {
      lineItemId: item.lineItemId,
      itemDescription: item.itemDescription,
      itemImageURL: item.itemImageURL,
      brandName: item.brandName,
    };
    return obj;
  }, {});
/* eslint-enable no-param-reassign */

export const ssrEligibilitySuccessMappedData = (
  state: Object,
  action: Object
) => {
  const {
    payload: { response },
  } = action;
  const {
    orderLineList: { orderLine },
    billingAddress: ssrCreateBillingAddress,
    et,
  } = response;
  const hrtvItemPayload = buildHrtvItemPayloads(orderLine);

  const ssrItems = mapSsrItems(orderLine);

  return {
    ...state,
    reasonCodes,
    et,
    ssrCreateBillingAddress,
    hrtvItemPayload,
    ssrItems,
  };
};
